import React from 'react';
import { styled, Flex, Icon } from '@goodrx/matisse';
import { UniversalLink } from 'app/components/links/UniversalLink';

const Wrapper = styled(Flex)`
  a {
    color: ${(p) => p.theme.colors.black};
    margin-left: 5px;
  }

  span {
    font-weight: 500;
  }

  a {
    font-weight: bold;
  }
`;

const LinkContent = ({ hideChevron, small }: { hideChevron?: boolean; small?: boolean }) => (
  <>
    {' '}
    Sign in
    {hideChevron ? null : (
      <>
        {' '}
        <Icon
          name="chevron-right"
          size={small ? 14 : 16}
          style={{ position: 'relative', top: 1, marginLeft: -5 }}
          color="black"
        />
      </>
    )}
  </>
);

export const SignInCta = ({
  small,
  className,
  useNextLink,
  hideChevron,
}: {
  small?: boolean;
  className?: string;
  useNextLink?: boolean;
  hideChevron?: boolean;
}) => (
  <Wrapper className={className}>
    <span>
      Already have an account?
      {useNextLink ? (
        <UniversalLink href="/login">
          <LinkContent hideChevron={hideChevron} small={small} />
        </UniversalLink>
      ) : (
        <UniversalLink to="/login">
          <LinkContent hideChevron={hideChevron} small={small} />
        </UniversalLink>
      )}
    </span>
  </Wrapper>
);
